// removed by extract-text-webpack-plugin
module.exports = {"eventList":"_1GeQtqKtFXYktjkvscJy4I","date":"_3wDUn89s_eeKSHgKyzfQ61","event":"_3QgRXVXcLlSJfH5KfhRwYS"};


//////////////////
// WEBPACK FOOTER
// ../components/ListFilteredEvents/style.module.less
// module id = 971
// module chunks = 0